import type { BookingType } from '$/_const/trip/WhatHasBeenBookedType.ts';

export const needsStartTimeReminder = (booking: { bookingType: BookingType; dateTime?: string }): boolean =>
  booking.bookingType !== 'flight' &&
  booking.bookingType !== 'stay' &&
  !!booking.dateTime?.trim() &&
  !booking.dateTime.includes('T');
